function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 20c0 1.507 1.076 3 2.714 3h8.572C17.924 23 19 21.507 19 20V4c0-1.507-1.076-3-2.714-3H7.714C6.076 1 5 2.493 5 4v16zm2.714 1C7.46 21 7 20.703 7 20V4c0-.702.459-1 .714-1h8.572c.255 0 .714.298.714 1v16c0 .703-.459 1-.714 1H7.714z"
});

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "#9193A9"
  }, props), _ref, _ref2);
};

export default SvgPhone;